import useUploadFileToOneDrive from './useUploadFileToOneDrive';
import UploadWithExternalDrive, {
  type UploadWithExternalDriveProps,
} from '../utils/upload/UploadWithExternalDrive';

type UploadWithOneDriveProps = Omit<
  UploadWithExternalDriveProps,
  'variant' | 'onUploadFile'
>;

const UploadWithOneDrive = (props: UploadWithOneDriveProps) => {
  const uploadFileToOneDrive = useUploadFileToOneDrive();

  return (
    <UploadWithExternalDrive
      variant="onedrive"
      onUploadFile={uploadFileToOneDrive}
      {...props}
    />
  );
};

export default UploadWithOneDrive;
